import {useEffect} from 'react'
import {useRouteError} from 'react-router-dom'
import {reportError} from '../../../common/errors/reportError'
import SorryPage from '../../pages/SorryPage'

const RouterErrorElement = () => {
  const error = useRouteError()

  useEffect(() => {
    reportError(error, 'RouterErrorElement')
  }, [error])

  const errObj = error instanceof Error ? error : new Error(String(error))
  return <SorryPage variant="fatal" error={errObj} />
}

export default RouterErrorElement
